import { useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"
import { useGetMyDepartmentsQuery } from "shared/redux/endpoints/procurement"
import { departmentList } from "pages/procurement/components/payment/create/NonPoPaymentBuilder"

// Department managers are defined by data (pro.department_role can map any
// role), not by a role code — so this asks the BE instead of matching names.
const useIsDepartmentManager = () => {
  const { accessToken } = useSelector(selectAuth)
  const { data } = useGetMyDepartmentsQuery(undefined, { skip: !accessToken })
  return departmentList(data).some((d) => d.isManager)
}

export default useIsDepartmentManager
